import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--primary")
          .trim() || "#19466B",
      light:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--primary-light")
          .trim() || "#3B6F9E",
      dark:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--primary-dark")
          .trim() || "#0F2E4A",
    },
    secondary: {
      main:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--accent")
          .trim() || "#FF9800",
    },
    background: {
      default:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--background-light")
          .trim() || "#F8FAFC",
    },
    text: {
      primary:
        getComputedStyle(document.documentElement)
          .getPropertyValue("--text-main")
          .trim() || "#1E293B",
    },
  },
  typography: {
    fontFamily: 'Poppins, "IBM Plex Sans Arabic", sans-serif',
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 500 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 16px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme }) => ({
          "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }),
      },
    },
  },
});
